import React from "react";
import { playbookItems } from "../../data/procrmData";

function Playbooks() {
  return (
    <section className="procrm-panel crm-section">
      <div className="panel-heading">
        <div>
          <span className="eyebrow">Knowledge Base</span>
          <h2>ProCRM playbooks</h2>
        </div>
      </div>

      <div className="playbook-list crm-playbook-grid">
        {playbookItems.map((item) => (
          <div className="playbook-card" key={item.title}>
            <span>{item.tag}</span>
            <h3>{item.title}</h3>
            <p>{item.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Playbooks;